/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelReviewItem
 */
export interface HotelReviewItem {
    /**
     * Name of the user who submitted the review.
     * @type {string}
     * @memberof HotelReviewItem
     */
    authorName?: string;
    /**
     * URL of the author's Google Maps profile.
     * @type {string}
     * @memberof HotelReviewItem
     */
    authorUrl?: string;
    /**
     * Language code of the review (e.g., "en", "fr").
     * @type {string}
     * @memberof HotelReviewItem
     */
    language?: string;
    /**
     * URL of the author's profile picture.
     * @type {string}
     * @memberof HotelReviewItem
     */
    profilePhotoUrl?: string;
    /**
     * Rating given by the user (1 to 5).
     * @type {number}
     * @memberof HotelReviewItem
     */
    rating?: number;
    /**
     * Human-readable time since the review was posted.
     * @type {string}
     * @memberof HotelReviewItem
     */
    relativeTimeDescription?: string;
    /**
     * The content of the review.
     * @type {string}
     * @memberof HotelReviewItem
     */
    text?: string;
    /**
     * Unix timestamp of when the review was posted.
     * @type {number}
     * @memberof HotelReviewItem
     */
    time?: number;
}

/**
 * Check if a given object implements the HotelReviewItem interface.
 */
export function instanceOfHotelReviewItem(value: object): value is HotelReviewItem {
    return true;
}

export function HotelReviewItemFromJSON(json: any): HotelReviewItem {
    return HotelReviewItemFromJSONTyped(json, false);
}

export function HotelReviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelReviewItem {
    if (json == null) {
        return json;
    }
    return {
        
        'authorName': json['author_name'] == null ? undefined : json['author_name'],
        'authorUrl': json['author_url'] == null ? undefined : json['author_url'],
        'language': json['language'] == null ? undefined : json['language'],
        'profilePhotoUrl': json['profile_photo_url'] == null ? undefined : json['profile_photo_url'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'relativeTimeDescription': json['relative_time_description'] == null ? undefined : json['relative_time_description'],
        'text': json['text'] == null ? undefined : json['text'],
        'time': json['time'] == null ? undefined : json['time'],
    };
}

export function HotelReviewItemToJSON(json: any): HotelReviewItem {
    return HotelReviewItemToJSONTyped(json, false);
}

export function HotelReviewItemToJSONTyped(value?: HotelReviewItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'author_name': value['authorName'],
        'author_url': value['authorUrl'],
        'language': value['language'],
        'profile_photo_url': value['profilePhotoUrl'],
        'rating': value['rating'],
        'relative_time_description': value['relativeTimeDescription'],
        'text': value['text'],
        'time': value['time'],
    };
}

